<template>
  <v-card :style="cardStyle"
          class="mx-1 my-2 py-7 pr-4 pl-6 strategy-card"
  >
    <v-card-text v-if="cardItem.category" class="strategy-type px-0 pt-0 pb-0">
      {{ cardItem.category.name }}
    </v-card-text>
    <v-card-title class="align-content-start strategy-name px-0 pt-2"
                  style="line-height: 1.20!important;">
      {{ cardItem.name }}
    </v-card-title>
    <v-card-actions class="px-0 pt-0 pb-0 text-right">
      <v-btn class="strategyInfoBtn" text @click="goToDetailsPage()">
        Informationen
      </v-btn>
      <v-btn class="strategySelectionBtn" dark @click="selectStrategy(cardItem.id)">
        Wählen
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "FinStrategyActionCard",
  props: {
    /** The item to display, must contain at least the attributes: id, name, isLexikonCard */
    cardItem: {
      type: Object,
      required: true
    },
    /** The router navigation object to execute on info button click */
    infoNavigation: {
      type: Object
    },
    /** Function (1 parameter = selected strategy id) to be executed if the select button is clicked */
    selectionFunction: {
      type: Function
    }
  },
  computed: {
    cardStyle() {
      let borderColor = 'transparent'
      if (this.cardItem.category) {
        borderColor = this.$finStrategyColors.find(sc => sc.type === this.cardItem.category.id)?.color || 'transparent'
      }

      return {
        borderTop: '6px solid ' + borderColor,
        backgroundColor: (this.cardItem.isLexikonCard ? this.$finColors.accentBlue : this.$finColors.primaryLight),
        width: (this.$vuetify.breakpoint.smAndDown ? 255 : 275) + 'px'
      }
    },
  },
  methods: {
    goToDetailsPage() {
      if (this.infoNavigation) {
        this.$router.push(this.infoNavigation)
      }
    },
    selectStrategy(strategyId) {
      if (this.selectionFunction && typeof this.selectionFunction === 'function') {
        this.selectionFunction(strategyId)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  &:link, &:visited, &:hover, &:active {
    text-decoration: none;
  }
}

.strategy-card, .lexikon-card {
  box-shadow: $fin-color-card-shadow !important;
  border: 1px solid $fin-color-light-sky-blue;
}

.strategy-type {
  font-size: 12px !important;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 1px;
  line-height: 1.17 !important;
  color: $fin-color-cool-grey !important;
  text-transform: uppercase;
}

.strategy-name {
  font-size: 18px !important;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  height: 68px;
}

.strategy-teaser {
  font-size: 14px !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-overflow: ellipsis;
  line-height: 19px !important;
  position: relative;
  overflow: hidden;
}

.strategy-teaser::before {
  position: absolute;
  content: "...";
  background-color: white;
  padding-left: 3px;
  padding-right: 13px;
  right: 0;
  bottom: 0;
}

.v-card__text.lexikon-card__title {
  font-size: 20px !important;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal !important;
  letter-spacing: normal;
  color: white !important;

  @media only screen and (max-width: 960px) {
    font-size: 16px;
  }
}

.v-card__text.lexikon-card__text {
  font-size: 14px !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5 !important;
  letter-spacing: normal;
  color: white !important;
}

.v-card__text.lexikon-card__moreText {
  font-size: 14px !important;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14 !important;
  letter-spacing: normal;
  color: white !important;
}
</style>
